import styled from "styled-components";

interface RectProps {
  color: string;
}
interface WrapperProps {
  numPages: number;
}

export const ViewerWrapper = styled.div`
  background-color: #eef3fb;
  max-width: 820px;
  width: fit-content;
`;
export const ContainerSvg = styled.div`
  overflow: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    padding-bottom: 60px;
  }
`;

export const Wrapper = styled.svg<WrapperProps>`
  width: 284px;
  height: ${({ numPages }) => numPages * 401.7225806451613 + ((numPages + 2) * 4)}px;
  padding: 5px 0;

  background-color: #ccc;
  position: relative;

  & image {
    width: 284px;
    height: 401.7225806451613px;
  }

  @media (min-width: 375px) {
    width: 330px;
    height: ${({ numPages }) => numPages * 466.7903225806452 + ((numPages + 2) * 4)}px;
  }
  @media (min-width: 375px) {
    & image {
      width: 330px;
      height: 466.7903225806452px;
    }
  }
  @media (min-width: 426px) {
    width: 384px;
    height: ${({ numPages }) => numPages * 543.1741935483871 + ((numPages + 2) * 4)}px;
  }
  @media (min-width: 426px) {
    & image {
      width: 384px;
      height: 543.1741935483871px;
    }
  }
  @media (min-width: 768px) {
    width: 688px;
    height: ${({ numPages }) => numPages * 973.1870967741935 + ((numPages + 2) * 4)}px;
  }
  @media (min-width: 768px) {
    & image {
      width: 688px;
      height: 973.1870967741935px;
    }
  }
  @media (min-width: 1024px) {
    width: 960px;
    height: 1357px;
    height: ${({ numPages }) => numPages * 1357 + ((numPages + 2) * 4)}px;
  }
  @media (min-width: 1024px) {
    & image {
      width: 960px;
      height: 1357px;
    }
  }
`;
export const DocumentWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  justify-content: center;
`;

export const Rect = styled.rect<RectProps>`
  fill: ${({ color }) => color};
  opacity: 0.3;
  z-index: 99999;
`;
export const Container = styled.div`
  /* overflow: auto; */
  height: calc(100vh - 80px);
  width: 100%;
  background-color: #ccc;
  position: relative;
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    align-items: center;
  }
`;
export const TopWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  align-items: center;
  position: sticky;
  top: 0px;
  z-index: 2;
  background: #eceef0;
  box-shadow: 0px 2px 2px -1px #2c2c2c;
  width: 100%;
  font-size: 14px;
  padding: 10px 6px 6px 6px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    box-shadow: 0px -1px 1px #2c2c2c;
  }
  @media (max-width: 1440px) {
    font-size: 12px;
  }
`;

interface TopWrapperSpanProps {
  isColumn?: boolean;
}
export const TopWrapperSpan = styled.span<TopWrapperSpanProps>`
  display: flex;
  flex-direction: ${(props) => (props.isColumn ? "column" : "row")};
  gap: 5px;
  font-weight: normal;
  color: #2c2c2c;
  overflow: hidden;
  @media (max-width: 768px) {
    display: none;
    &:first-child {
      display: none;
    }
  }
`;
export const TopWrapperP = styled.p`
  font-family: "Archivo-Bold";
  color: #2c2c2c;
  @media (max-width: 765px) {
    font-size: 0.85rem;
  }
  @media (max-width: 670px) {
    font-size: 0.6rem;
  }
`;

interface ButtonProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
  cursor?: string;
  isFilled?: boolean;
  showButton?: boolean;
  color?: string;
  height?: string;
}
export const WrapperButton = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  @media (max-width: 426px) {
    gap: 10px;
    padding: 0 5px;
  }
`;
export const Button = styled.button<ButtonProps>`
  display:${(props) => !props.showButton ? "none" : "flex"};
  align-items: center;
  justify-content: center;
  font-size: 12px;
  gap: 5px;
  background-color: ${(props) => props.backgroundColor};
  cursor: ${(props) => props.cursor || "pointer"};
  pointer-events: ${(props) => !props.isFilled && "none"};
  border: none;
  border-radius: 99px;
  width: fit-content;
  height: ${(props) => props.height || "40px"};
  padding: 0 8px;
  font-family: "Archivo-Regular";
  color: ${(props) => props.color || "#fff"};
  text-transform: uppercase;

  &:hover {
    transition: all 0.2s;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
  a {
    text-decoration: none;
    color: #fff;
  }
  
`;
export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2rem;
  position: fixed;
  width: 100%;
  bottom: 0;
  pointer-events: none;

  button {
    pointer-events: visible;
    &:hover {
      transition: all 0.2s;
      background-color: #32568c;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
  @media (min-width: 1500px) {
    padding: 2rem 12rem;
  }
  @media (min-width: 2000px) {
    padding: 2rem 28rem;
  }
  @media (min-width: 2200px) {
    padding: 2rem 35rem;
  }
`;
interface ButtonPrevNextProps {
  cursor?: string;
}
export const ButtonNext = styled.button<ButtonPrevNextProps>`
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #355B94;
  cursor: ${(props) => props.cursor || "pointer"};
  border: none;
  border-radius: 99px;
  text-transform: uppercase;
  font-family: "Archivo-Regular";
  height: 35px;
  padding: 10px;
  font-size: 12px;
  color: #fff;
`;

export const ButtonPrev = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #355B94;
  cursor: pointer;
  border: none;
  border-radius: 99px;
  font-size: 12px;
  text-transform: uppercase;
  font-family: "Archivo-Regular";
  height: 35px;
  padding: 10px;
  color: #fff;
`;

export const ContainerModalInputs = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const ButtonModal = styled.button<ButtonProps>`
  background-color: ${(props) => props.backgroundColor};
  cursor: ${(props) => props.cursor || "pointer"};
  border: none;
  width: auto;
  margin-top: 10px;
  padding: 10px;
  color: #fff;
  font-family: "Archivo-Bold";
  &:hover {
    transition: all 0.2s;
    box-shadow: 0px 0px 4px black;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
`;
